import React from "react";
import { OMSButtonStyleL } from "../../../../app/common/common-components/OMSButton";
import { OMSDropdown } from "../../../../app/common/common-components/OMSDropdown";

const ProvinceDropdown = ({
  ProvinceDD,
  ProvinceID,
  handleProvinceDDChange,
  ButtonStatus,
  onCreateProvinceClick,
  onUpdateProvinceClick,
  onDeleteProvinceClick
}) => (
  <div className="form-group">
    <label htmlFor="ProvinceDD">Province</label>
    <OMSDropdown
      id="ProvinceDD"
      options={ProvinceDD}
      valueField="value"
      labelField="text"
      value={ProvinceID}
      onChange={handleProvinceDDChange}
    />
    {ProvinceID === "" ? (
      <div style={{ marginTop: 5 }}>
        <OMSButtonStyleL
          type="button"
          style={{ marginRight: 10 }}
          ui_icon="fa-plus"
          ui_type="delete"
          ui_text="Add"
          ui_processing_text=""
          processing={false}
          disabled={ButtonStatus.disabled}
          onClick={onCreateProvinceClick}
        />
      </div>
    ) : (
      <div style={{ marginTop: 5 }}>
        <OMSButtonStyleL
          type="button"
          style={{ marginRight: 10 }}
          ui_icon="fa-plus"
          ui_type="delete"
          ui_text="Add"
          ui_processing_text=""
          processing={false}
          disabled={ButtonStatus.disabled}
          onClick={onCreateProvinceClick}
        />
        <OMSButtonStyleL
          type="button"
          style={{ marginRight: 10 }}
          ui_icon="fa-edit"
          ui_type="delete"
          ui_text="Edit"
          ui_processing_text=""
          processing={false}
          disabled={ButtonStatus.disabled}
          onClick={onUpdateProvinceClick}
        />
        <OMSButtonStyleL
          type="button"
          ui_icon="fa-trash-o"
          ui_type="delete"
          ui_text="Delete"
          ui_processing_text="Deleting.."
          processing={ButtonStatus.processing_delete}
          disabled={ButtonStatus.disabled}
          onClick={onDeleteProvinceClick}
        />
      </div>
    )}
  </div>
);

export default ProvinceDropdown;
